import Swiper, {Pagination, Autoplay, EffectFade, Navigation } from "swiper";
Swiper.use([Pagination, Autoplay, EffectFade, Navigation]);

const Carousels = {

	init: () => {
		Carousels.initImagesCarousel();
		Carousels.initOurWinesCarousels();
		Carousels.initHeroCarousel();
	},

	initHeroCarousel: () => {
		const heros = document.querySelectorAll(`.hero__swiper`);
		heros.forEach((element) => {
		    const swiper = new Swiper(element, {
		        slidesPerView: 1,
		        autoHeight: true,
		        navigation: {
					prevEl: element.closest('.hero').querySelector('.hero__navigation__button--prev'),
					nextEl: element.closest('.hero').querySelector('.hero__navigation__button--next'),
		        },
		        centeredSlides: true,
		        rewind: true,
		        autoplay: {
		            delay: 10000,
		            disableOnInteraction: false,
		        },
		        // effect: "fade",
		    });
		})
	},

	initImagesCarousel: () => {
		const steps = document.querySelectorAll(`.images-carousel__swiper`);
		steps.forEach((element) => {
		    const swiper = new Swiper(element, {
		        slidesPerView: 3,
		        spaceBetween: 66,
		        rewind: true,
		        breakpoints: {
					0: {
						slidesPerView: 1,
						spaceBetween: 0,
					},
					768: {
						slidesPerView: 3,
						spaceBetween: 35,
					},
		            1200: {
		                slidesPerView: 3,
		                spaceBetween: 55,
		            },
		        },
		        pagination: {
		            el: element.closest('.images-carousel').querySelector('.carousel-pagination'),
		            clickable: true,
		        },
		    });
		})
	},

	initOurWinesCarousels: () => {
		const carousels = document.querySelectorAll(`.archive-product__category__swiper`);
		carousels.forEach((element) => {

			const isBundle = (element.getAttribute('data-bundle') == '1');

		    const swiper = new Swiper(element, {
		        slidesPerView: isBundle ? 1 : 4,
		        spaceBetween: 50,
		        // loop: true,
		        navigation: {
		            nextEl: element.closest('.archive-product__category').querySelector('.archive-product__category__navigation__button--next'),
		            prevEl: element.closest('.archive-product__category').querySelector('.archive-product__category__navigation__button--prev'),
		        },
		        breakpoints: {
		            0: {
		                slidesPerView: isBundle ? 1 : 2,
		                spaceBetween: 20,
		            },
					768: {
						slidesPerView: isBundle ? 1 : 3,
						spaceBetween: 20,
					},
					992: {
						slidesPerView: isBundle ? 1 : 3,
						spaceBetween: 30,
					},
					1200: {
						slidesPerView: isBundle ? 1 : 4,
						spaceBetween: 30,
					},
					1600: {
						slidesPerView: isBundle ? 1 : 4,
						spaceBetween: 50,
					},
		        },
		    });
		})
	}

}
export default Carousels;
